module.exports = __webpack_public_path__ + "static/media/finish-registration.e7194e5d.svg";